import { render, staticRenderFns } from "./GeschaeftspartnerlisteNewViva.vue?vue&type=template&id=159b2e02"
import script from "./GeschaeftspartnerlisteNewViva.vue?vue&type=script&lang=js"
export * from "./GeschaeftspartnerlisteNewViva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports